import {Component, OnInit} from '@angular/core';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {fuseAnimations} from '../../../../core/animations';
import {FuseConfigService} from '../../../../core/services/config.service';

@Component({
    selector: 'org-platforms',
    templateUrl: './org-platforms.component.html',
    styleUrls: ['./org-platforms.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class OrgPlatformsComponent implements OnInit {
  platforms = [];
  displayedColumns = [ 'title', 'status', 'description', 'infoUrl'];
  organizationId;
  constructor(public platformsService: PlatformsService,
              private fuseConfig: FuseConfigService) {
    this.fuseConfig.organizationId.subscribe((res) => {
      if (res) {
        this.organizationId = parseInt(res, 10);
        this.getPlatforms();
      }
    });
  }

  ngOnInit() {

  }

  getPlatforms() {
    this.platformsService.getByOrganizationId(this.organizationId).subscribe((res: any) => {
      this.platforms = res;
    });
  }
}
